import { MissingCountryStateAlert, UnpaidInvoicesAlert } from '@app/components/various/GeneralAlertMessages';

export const OrderGeneralAlerts = () => {
  return (
    <div className="mx-auto not-empty:grid not-empty:gap-4">
      <UnpaidInvoicesAlert />
      <MissingCountryStateAlert />
    </div>
  );
};
